<template>
  <div>
    <div class="box">
      <el-page-header
        @back="$router.go(-1)"
        :content="$t('tReadDetail')"
      ></el-page-header>
    </div>
    <el-card class="content mt20">
      <el-form
        label-position="left"
        :model="ruleForm"
        ref="ruleForm"
        label-width="120px"
        class="ruleFrom row"
      >
        <el-form-item
          :label="$t('readList.create_time')"
          prop="create_time"
          class="col-6 mb0"
        >
          <div>{{ ruleForm.create_time }}</div>
        </el-form-item>
        <el-form-item
          :label="$t('readList.update_time')"
          prop="update_time"
          class="col-6 mb0"
        >
          <div>{{ ruleForm.update_time }}</div>
        </el-form-item>
        <el-form-item
          :label="$t('readList.time')"
          prop="start_time"
          class="col-12 mb0"
        >
          <div>{{ ruleForm.start_time }}~{{ ruleForm.end_time }}</div>
        </el-form-item>
        <el-form-item
          :label="$t('readList.apply_time')"
          prop="apply_start"
          class="col-12 mb0"
        >
          <div>{{ ruleForm.apply_start }}~{{ ruleForm.apply_end }}</div>
        </el-form-item>
      </el-form>
    </el-card>
    <h3 class="mt20 b">{{ $t('readList.read_information') }}</h3>
    <el-card class="content mt20">
      <el-form
        label-position="left"
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="row"
      >
        <el-form-item
          :label="$t('readList.title')"
          prop="title"
          class="col-6 mb0"
        >
          <div>{{ ruleForm.title }}</div>
        </el-form-item>
        <el-form-item
          :label="$t('readList.type')"
          prop="type"
          class="col-6 mb0"
        >
          <div>{{ type(ruleForm.type) }}</div>
        </el-form-item>
        <el-form-item
          :label="$t('readList.subtitle')"
          prop="subtitle"
          class="col-12 mb0"
        >
          <div>{{ ruleForm.subtitle }}</div>
        </el-form-item>
        <el-form-item
          v-if="!show_before"
          :label="$t('readList.content')"
          prop="content"
          class="col-12 mb0"
        >
          <div class="word_break" v-html="ruleForm.content"></div>
        </el-form-item>
        <el-form-item
          v-if="!show_before"
          :label="$t('readList.read_calendar')"
          prop="read_calendar"
          class="col-12 mb0"
        >
          <div class="word_break" v-html="ruleForm.read_calendar"></div>
        </el-form-item>
        <el-form-item
          v-if="!show_before"
          :label="$t('readList.read_task')"
          prop="read_task"
          class="col-12 mb0"
        >
          <div class="word_break" v-html="ruleForm.read_task"></div>
        </el-form-item>
        <el-form-item
          v-if="!show_before"
          :label="$t('readList.challenge_rank')"
          prop="challenge_rank"
          class="col-12 mb0"
        >
          <div class="word_break" v-html="ruleForm.challenge_rank"></div>
        </el-form-item>
        <el-form-item
          v-if="!show_before"
          :label="$t('readList.challenge_guide')"
          prop="challenge_guide"
          class="col-12 mb0"
        >
          <div class="word_break" v-html="ruleForm.challenge_guide"></div>
        </el-form-item>
      </el-form>
    </el-card>
    <h3 class="mt20 b">{{ $t('readList.read_setting') }}</h3>
    <el-card class="content mt20">
      <el-form
        label-position="left"
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="row"
      >
        <el-form-item
          :label="$t('readList.apply')"
          label-width="170px"
          prop="apply_num"
          class="col-6 mb0"
        >
          <div>{{ ruleForm.apply_num }}/{{ ruleForm.total_num }}</div>
        </el-form-item>
        <el-form-item
          :label="$t('readList.price')"
          prop="price"
          class="col-6 mb0"
        >
          <div>{{ ruleForm.price }}</div>
        </el-form-item>
        <el-form-item
          :label="$t('readList.option')"
          prop="option"
          class="col-12 mb0"
        >
          <div>{{ ruleForm.option }}</div>
        </el-form-item>
        <el-form-item
          :label="$t('readList.option_desc')"
          prop="option_desc"
          class="col-12 mb0"
        >
          <div>{{ ruleForm.option_desc }}</div>
        </el-form-item>
        <el-form-item
          :label="$t('readList.other_title')"
          prop="other_title"
          class="col-12 mb0"
        >
          <div>{{ ruleForm.other_title }}</div>
        </el-form-item>
        <el-form-item
          :label="$t('readList.other_content')"
          prop="other_content"
          class="col-12 mb0"
        >
          <div>{{ ruleForm.other_content }}</div>
        </el-form-item>
        <el-form-item
          :label="$t('readList.refund_desc')"
          prop="refund_desc"
          class="col-12 mb0"
        >
          <div v-html="ruleForm.refund_desc"></div>
        </el-form-item>
        <el-form-item
          :label="$t('readList.search_tag')"
          prop="search_tag"
          class="col-12 mb0"
        >
          <div>{{ ruleForm.search_tag }}</div>
        </el-form-item>
        <el-form-item
          :label="$t('readList.cover')"
          prop="cover"
          class="col-12 mb0"
        >
          <el-image
            style="width: 100px; height: 100px"
            :src="ruleForm.cover"
            :preview-src-list="[ruleForm.cover]"
          >
          </el-image>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { readDetail } from '@/api/api';
export default {
  name: 'readDetail',
  data() {
    return {
      ruleForm: {
        create_time: '',
        update_time: '',
        type: '',
        title: '',
        subtitle: '',
        content: '',
        cover: '',
        option: '',
        option_desc: '',
        other_title: '',
        other_content: '',
        price: 0,
        apply_num: 0,
        total_num: 0,
        start_time: '',
        end_time: '',
        apply_start: '',
        apply_end: '',
        refund_desc: '',
        search_tag: '',
        read_calendar: '',
        read_task: '',
        challenge_rank: '',
        challenge_guide: '',
      },
    };
  },
  computed: {
    id() {
      return Number.isNaN(Number(this.$route.query.id))
        ? undefined
        : Number(this.$route.query.id);
    },
  },
  methods: {
    type(type) {
      switch (type) {
        case 0:
          return this.$t('readList.type0');
        case 1:
          return this.$t('readList.type1');
      }
    },
    async get_info() {
      const information = await readDetail(this.id);
      this.ruleForm = information;
    },
  },
  created() {
    this.get_info();
  },
};
</script>
<style lang="scss" scoped>
.v-for-span + .v-for-span::before {
  content: '/';
}
/deep/.el-form-item__content {
  word-wrap: break-word;
  font-weight: bold;
}
</style>
